<template>
    <div class="profile-item">
        <div class="profile-item__element profile-item__title">
            {{ title }}
        </div>
        <div class="profile-item__element profile-item__value">
            {{ value }}
        </div>
    </div>
</template>

<script>
export default {
    name : 'ProfileItem',
    props: {
        title: {
            type    : String,
            required: true
        },
        value: {
            type    : String,
            required: true
        }
    }
};
</script>

<style lang="scss">
@import "ProfileItem";
</style>